<template>
  <div>
    <div class="product-filters">
      <div class="row">
        <template v-if="displayProductType">
          <div class="col-12 col-md-6 col-lg filter" data-aos="fade-in">
            <label>Category</label>
            <select ref="productType" class="form-control" name="type" v-on:change="typeChanged">
              <option v-for="productType in this.productTypes" :value="productType.id" :key="productType.id"
                      :selected="productTypeSlug === productType.slug">
                {{productType.name}}
              </option>
            </select>
          </div>
        </template>
        <div v-for="(filter, index) in filters" :key="index" class="col-12 col-md-6 col-lg filter" data-aos="fade-in">
          <label :for="filter.name">{{filter.label}}</label>
          <select class="form-control" :name="filter.name" v-on:change="filterChanged" :disabled="filter.options.length === 0">
            <option :selected="filter.selected === null">All</option>
            <option v-for="option in filter.options" :value="option.id" :key="option.id" :selected="filter.selected === option.id">{{option.name}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ProductFilters',
    props: {
      displayProductType: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        productTypeSlug: 'wine',
        producerSlug: null,
        productTypes: [],
        filters: []
      };
    },
    methods: {
      resetFilters: function () {
        this.filters = [
          {
            name: 'producer',
            label: "Producer",
            selected: null,
            options: []
          },
          {
            name: 'country-of-origin',
            label: "Country of Origin",
            selected: null,
            options: [],
          }, {
            name: 'region',
            label: "Region",
            selected: null,
            options: []
          },
          {
            name: 'grape',
            label: "Varietal",
            selected: null,
            options: []
          },
          {
            name: 'range',
            label: "Range",
            selected: null,
            options: []
          },
          {
            name: 'vegan-friendly',
            label: "Vegan",
            selected: null,
            options: []
          },
        ]
      },
      populateDropDowns: function (productTypeId, producerSlug = null) {

        const apiFilters = [
          {
            property: 'product_type_id',
            value: productTypeId,
            operator: '='
          },
        ];

        this.productTypes.map(productType => {
          if (productType.id === productTypeId) {
            productType.categories.map(category => {
              this.filters.map(filter => {
                if (category.slug === filter.name) {
                  filter.options = this.$root.sortByProperty(category.category_options, 'name');

                  if (producerSlug) {
                    category.category_options.map(option => {
                      if (category.name === 'Producer' && option.value === producerSlug) {
                        filter.selected = option.id;

                        apiFilters.push({
                          property: 'category_options',
                          value: [option.id],
                          operator: '='
                        });
                      }
                    });
                  }
                }
              })
            });
          }
        });

        this.$emit('filter-changed', apiFilters);
      },
      typeChanged: function(event){
        const value = parseInt(event.target.value);
        this.resetFilters();
        this.populateDropDowns(value);
      },
      filterChanged: function (event) {
        const name = event.target.name;
        const value = event.target.value !== 'All' ? parseInt(event.target.value) : null;
        let apiFilters = [
          {
            property: 'category_options',
            value: [],
            operator: '='
          }
        ];

        if ('productType' in this.$refs) {
          apiFilters.push({
            property: 'product_type_id',
            value: this.$refs.productType.value,
            operator: '='
          });
        }

        for (let i = 0; i < this.filters.length; i++) {
          let filter = this.filters[i];

          if (filter.name === name) {
            filter.selected = value;
            this.filters[i] = filter;
          }

          if (filter.selected !== null) {
            apiFilters[0].value.push(filter.selected);
          }
        }

        this.$emit('filter-changed', apiFilters);
      }
    },
    created: function () {
      this.resetFilters();
      const pagination = {
        page: 1,
        pagination_interval: 100
      };

      if ('type' in this.$route.query) {
        this.productTypeSlug = this.$route.query.type;
      }

      if ('producer' in this.$route.query) {
        this.producerSlug = this.$route.query.producer;
      }

      this.$root.$api.getProductTypes(pagination)
              .then(response => {
                if (response.data != null) {
                  response.data.product_types.map(productType => {
                    this.productTypes.push(productType);

                    if (productType.slug === this.productTypeSlug) {
                      this.populateDropDowns(productType.id, this.producerSlug);
                    }
                  })
                }
              }).catch(error => {
        console.log(error);
      })
    }
  }
</script>
